export function recaptchaCallbackFunction(token, setVerified, validationUrl) {
    if (token.length && validationUrl) {
        fetch(validationUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        })
        .then(response => response.json())
        .then(data => {
            setVerified(data?.success || false)
            if (!data?.success) {
                setTimeout(() => {
                    (window as any).grecaptcha.reset()
                }, 0)
            }
        })
        .catch(error => {
            console.error('Error verifying reCAPTCHA token:', error)
            setVerified(false)
            setTimeout(() => {
                (window as any).grecaptcha.reset()
            }, 0)
        })
    } else {
        setVerified(false)
        setTimeout(() => {
            (window as any).grecaptcha.reset()
        }, 0)
    }
}